import { Link } from 'react-router-dom'
import { PiInstagramLogo, PiFacebookLogo, PiLinkedinLogo, PiGlobe } from 'react-icons/pi'

import { ROUTES } from '@/constants/routes'
import { LOGO, PROJECT_NAME } from '@/constants/common'

import styles from './Footer.module.css'

export function Footer() {
    const currentYear = new Date().getFullYear()

    const navLinks = [
        { to: ROUTES.home, label: 'Inicio' },
        { to: ROUTES.assignments, label: 'Mis Trabajos' },
        { to: ROUTES.register, label: 'Registrarse' },
    ]

    const socialLinks = [
        { href: 'https://www.facebook.com/profile.php?id=61559863243995', icon: PiFacebookLogo, label: 'Facebook' },
        { href: 'https://www.instagram.com/qolca.peru/', icon: PiInstagramLogo, label: 'Instagram' },
        { href: 'https://www.linkedin.com/in/qolca-solutions/', icon: PiLinkedinLogo, label: 'LinkedIn' },
        { href: 'https://qolca.org', icon: PiGlobe, label: 'Website' },
    ]

    return (
        <footer className={styles.footer}>
            <div className={styles.container}>
                {/* Left: Logo + tagline */}
                <div className={styles.brand}>
                    <Link to={ROUTES.home} className={styles.logo}>
                        <img src={LOGO.src} alt={LOGO.alt} className={styles.logoImg} />
                        <span className={styles.logoText}>{PROJECT_NAME}</span>
                    </Link>
                    <p className={styles.tagline}>Tu plataforma de trabajos freelance</p>
                </div>

                {/* Center: Nav links */}
                <nav className={styles.nav}>
                    {navLinks.map((link) => (
                        <Link key={link.label} to={link.to} className={styles.navLink}>
                            {link.label}
                        </Link>
                    ))}
                </nav>

                {/* Right: Social icons */}
                <div className={styles.social}>
                    {socialLinks.map((item) => (
                        <a
                            key={item.label}
                            href={item.href}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles.socialIcon}
                            aria-label={item.label}
                        >
                            <item.icon size={18} />
                        </a>
                    ))}
                </div>
            </div>

            {/* Bottom line */}
            <div className={styles.bottom}>
                <span>{currentYear} {PROJECT_NAME}. Todos los derechos reservados.</span>
                <span className={styles.separator}>|</span>
                <span>
                    Hecho por{' '}
                    <a
                        href="https://qolca.org"
                        target="_blank"
                        rel="noopener noreferrer"
                        className={styles.qolcaLink}
                    >
                        qolca
                    </a>
                </span>
            </div>
        </footer>
    )
}
